export function subtractHolidays({
  holidays,
  currentYear,
  monthIndex,
  workingDays,
  workingDaysInMonth,
  shift,
  lastWorkingDate,
}) {

  monthIndex = normalizeMonth(monthIndex);
  const deductedDates = new Set();

  const lastWorkingDateObj = lastWorkingDate ? new Date(lastWorkingDate) : null;

  for (const holiday of holidays) {
    const holidayDate = new Date(holiday.dates);

    const holidayYear = holiday.isRecurring
      ? currentYear
      : holidayDate.getFullYear();

    const holidayStart = new Date(
      holidayYear,
      holidayDate.getMonth(),
      holidayDate.getDate()
    );

    for (let i = 0; i < holiday.numberOfDays; i++) {
      const actualHolidayDate = new Date(holidayStart);
      actualHolidayDate.setDate(actualHolidayDate.getDate() + i);

      if (
        actualHolidayDate.getFullYear() !== currentYear ||
        actualHolidayDate.getMonth() !== monthIndex
      ) {
        continue;
      }

      if (lastWorkingDateObj && actualHolidayDate > lastWorkingDateObj) {
        continue;
      }

      const holidayWeekday = actualHolidayDate.toLocaleDateString("en-US", {
        weekday: "long",
      });
      const holidayShift = holiday.shift.toLowerCase();
      const currentShift = shift.toLowerCase();

      if (
        workingDays.includes(holidayWeekday) &&
        (holidayShift === currentShift || holidayShift === "general")
      ) {
        const dateKey = `${actualHolidayDate.getFullYear()}-${String(actualHolidayDate.getMonth() + 1).padStart(2, '0')}-${String(actualHolidayDate.getDate()).padStart(2, '0')}`;
        if (!deductedDates.has(dateKey)) {
          deductedDates.add(dateKey);
          workingDaysInMonth--;
        }
      }
    }
  }

  return workingDaysInMonth;
}

function normalizeMonth(month) {
  if (typeof month === "number") return month;

  const months = [
    "january", "february", "march", "april", "may", "june",
    "july", "august", "September", "october", "november", "december"
  ];

  const lower = String(month).toLowerCase();

  const index = months.indexOf(lower);

  if (index === -1) {
    console.warn("Invalid month provided:", month);
    return 0;
  }

  return index;
}


// WEBPACK FOOTER //
// ./src/utils/excludeholidayHours.js